import { Dropdown } from '@approvalmax/ui';
import { Box, Text } from '@approvalmax/ui/src/components';
import { miscHelpers } from '@approvalmax/utils';
import { getTemplateDisplayNameByCode } from 'modules/common/selectors/templateSelectors';
import { domain } from 'modules/data';
import { FC, useState } from 'react';
import bemFactory from 'react-bem-factory';

import { TwoDifferentValuesWarning } from '../TwoDifferentValuesWarning/TwoDifferentValuesWarning';
import { getRequestNameShort, getSystemName, getWarningLevel } from './PriceCheckIndicator.helpers';
import { messages } from './PriceCheckIndicator.messages';
import { PriceCheckIndicatorProps } from './PriceCheckIndicator.types';

const bem = bemFactory.block('rq-price-check-indicator');

/**
 * @deprecated Use new cells approach with warningLevel and warningMessage
 */
export const PriceCheckIndicator: FC<PriceCheckIndicatorProps> = (props) => {
    const {
        activatorTag = 'div',
        className,
        children,
        actualPrice,
        expectedPrice,
        disabled,
        integrationType,
        integrationCode,
        isMultiCurrency,
    } = props;

    const Activator = activatorTag;

    const warningLevel = disabled
        ? undefined
        : getWarningLevel(
              actualPrice,
              expectedPrice,
              isMultiCurrency,
              integrationCode === domain.IntegrationCode.NetSuiteInvoice
          );

    const [isOpen, setOpen] = useState(false);

    const systemName = getSystemName(integrationType);
    const requestName = getTemplateDisplayNameByCode(integrationCode);
    const requestNameShort = getRequestNameShort(integrationCode) || requestName;

    return (
        <Dropdown
            button={(ref) => (
                <Activator
                    ref={ref}
                    className={bem.add(className)()}
                    onMouseEnter={() => setOpen(true)}
                    onMouseLeave={() => setOpen(false)}
                >
                    {children({ warningLevel })}
                </Activator>
            )}
            isOpen={isOpen && !disabled && warningLevel !== undefined}
            onRequestClose={miscHelpers.noop}
        >
            {isMultiCurrency ? (
                <Box spacing='16' width={230} shadow='small' color='white100'>
                    <Text font='body' fontSize='small'>
                        {messages.multiCurrencyDescription}
                    </Text>
                </Box>
            ) : (
                <TwoDifferentValuesWarning
                    value1={expectedPrice}
                    value2={actualPrice}
                    label1={messages.expectedPriceText}
                    label2={messages.actualPriceText({ requestName: requestNameShort })}
                    description={messages.description({ requestName, systemName })}
                />
            )}
        </Dropdown>
    );
};

PriceCheckIndicator.displayName = 'PriceCheckIndicator';
